(() => {
  const loader = document.currentScript;
  if (!loader) return;

  const root = document.getElementById(`shopify-section-${loader.dataset.rvSectionId}`);
  if (!root) return;

  const urls = [
    loader.dataset.rvQuickAdd,
    loader.dataset.rvVariantPicker,
    loader.dataset.rvProductForm,
    loader.dataset.rvCustomSelect,
    loader.dataset.rvQuickOrderList
  ].filter(Boolean);

  const loadScript = (url) => {
    const absoluteUrl = new URL(url, window.location.href).href;
    const existing = Array.from(document.scripts).find((script) => script.src === absoluteUrl);
    if (existing) {
      if (existing.dataset.rvLoaded === 'true' || existing.readyState === 'complete') {
        return Promise.resolve();
      }
      return new Promise((resolve, reject) => {
        existing.addEventListener('load', resolve, { once: true });
        existing.addEventListener('error', reject, { once: true });
      });
    }

    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = absoluteUrl;
      script.onload = () => {
        script.dataset.rvLoaded = 'true';
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  };

  const loadAssets = () => {
    if (!window.riftValleyQuickAddAssets) {
      window.riftValleyQuickAddAssets = urls.reduce(
        (chain, url) => chain.then(() => loadScript(url)),
        Promise.resolve()
      );
    }
    return window.riftValleyQuickAddAssets;
  };

  const warmUp = () => {
    loadAssets().catch((error) => console.error('Quick add could not be loaded.', error));
  };

  root.addEventListener('pointerover', warmUp, { once: true, passive: true });
  root.addEventListener('focusin', warmUp, { once: true });
  root.addEventListener('touchstart', warmUp, { once: true, passive: true });

  root.addEventListener(
    'click',
    async (event) => {
      if (window.riftValleyQuickAddReady) return;

      const trigger = event.target.closest('.js-quick-add, .btn--atc');
      if (!trigger || !root.contains(trigger)) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      try {
        await loadAssets();
        window.riftValleyQuickAddReady = true;
        requestAnimationFrame(() => trigger.click());
      } catch (error) {
        console.error('Quick add could not be loaded.', error);
      }
    },
    true
  );
})();
